// @flow
import {logExperiment as abacusClientUtilsLogExperiment} from '@homeaway/abacus-client-utils';

import type {AbacusEvaluationData, AbacusExperimentValue} from './types';

export function evaluationIsVariant(
    evaluationData?: AbacusEvaluationData,
    variant?: AbacusExperimentValue
) {
    const evaluationValue = evaluationData ? evaluationData.value : 0;

    if (Array.isArray(variant)) {
        return variant.indexOf(evaluationValue) !== -1;
    }
    return variant === evaluationValue;
}

export function evaluationIsOn(evaluationData?: AbacusEvaluationData) {
    return evaluationData && evaluationData.value > 0;
}

export function logExperiment(evaluationData: AbacusEvaluationData) {
    const {
        experimentKey: {experimentName},
        value
    } = evaluationData;

    abacusClientUtilsLogExperiment(evaluationData);

    // istanbul ignore next
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.info(
            `%cLogged experiment: %c${experimentName} {${value}}`,
            'font-weight: bold',
            'font-weight: normal'
        );
    }
}
